import React, { Component } from 'react';
import { get } from '../../../shared/http/request';
import update from 'immutability-helper';
import { formatDateTime } from '../../../shared/utils/date';
import {
    Alert,
    Button,
    Col,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
    Panel,
    Row,
} from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import queryString from 'query-string';
import Select from 'react-select';
import { createIlocsDataDownloadBreadcrumb } from '../../../shared/utils/breadcrumbs';
import { canViewIlocsDownload } from '../../../shared/security/isActionAuthorized';
import { showAccessDeniedToast } from '../../../shared/security/showAccessDeniedToast';

const API_BASE_URL = 'api/reports';

class IlocsDataDownload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloadFilter: {
                ilocsDataStart: '',
                ilocsDataEnd: '',
                emcCode: '',
            },
            errors: {},
            indicator : false,
        };
        this.validateDownloadDataForm = this.validateDownloadDataForm.bind(this);
    }

    componentDidMount() {

    }

    handleDateChange = name => momentDate => {

        this.setState({
                    downloadFilter: update(this.state.downloadFilter, {
                        [name]: { $set: momentDate },
                    }),
                });
    };

    validateDownloadDataForm = e => {
        const { downloadFilter } = this.state;
        let errors = {};

        if (downloadFilter.ilocsDataStart === '' || downloadFilter.ilocsDataEnd === '') {
            errors.downloadDatesRequired = 'Unload dates are required for downloading data ';
        }

        if(downloadFilter.emcCode === ''){
            errors.emcCodeRequired = 'EMC Code is required to download ilocs data';
        }

        if (Object.keys(errors).length > 0) {
            this.setState(() => ({ errors }));
            e.preventDefault();
        }
        this.setState({indicator : true})
    };

    handleDownloadFilterChange = e => {
        this.setState({
            downloadFilter: update(this.state.downloadFilter, {
                [e.target.name]: { $set: e.target.value },
            }),
        });
    };

    prepareFormDataForPost = form => {
        if(this.state.indicator){
                const search = update(form, {
                    ilocsDataStart: {
                        $set: form.ilocsDataStart ? moment.utc(form.ilocsDataStart).format('YYYY-MM-DDTHH:ss:ss.SSS') : '',
                    },
                    ilocsDataEnd: {
                        $set: form.ilocsDataEnd ? moment.utc(form.ilocsDataEnd).format('YYYY-MM-DDTHH:ss:ss.SSS') : '',
                    },
                });

                return queryString.stringify(search);
        }else{
            return queryString.stringify(form);
        }

    };

    render() {
        const {errors , downloadFilter } = this.state;
        return (
            <Col sm={12}>
                {createIlocsDataDownloadBreadcrumb()}
                <Form horizontal>
                    <Row>
                        <Col sm={6} className="no-gutter">
                            <Panel header="Timeframe">
                                <FormGroup controlId="ilocsDataStart">
                                    {errors.downloadDatesRequired && (
                                        <Alert bsStyle="danger">{errors.downloadDatesRequired}</Alert>
                                    )}
                                    {errors.emcCodeRequired && (
                                        <Alert bsStyle="danger">{errors.emcCodeRequired}</Alert>
                                    )}
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Unload Start Date&Time *
                                    </Col>
                                    <Col sm={8}>
                                        <Datetime
                                            value={downloadFilter.ilocsDataStart}
                                            onChange={this.handleDateChange('ilocsDataStart')}
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat="HH:mm"
                                            inputProps={{
                                                maxLength: 255,
                                                placeholder: '...',
                                            }}
                                            closeOnSelect
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId="ilocsDataEnd">
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Unload End Date&Time *
                                    </Col>
                                    <Col sm={8}>
                                        <Datetime
                                            value={downloadFilter.ilocsDataEnd}
                                            onChange={this.handleDateChange('ilocsDataEnd')}
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat="HH:mm"
                                            inputProps={{
                                                maxLength: 255,
                                                placeholder: '...',
                                            }}
                                            closeOnSelect
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId="emcCode">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        EMC Code *
                                    </Col>
                                    <Col sm={8}>
                                        <FormControl
                                            type="text"
                                            maxLength="1000"
                                            name="emcCode"
                                            value={downloadFilter.emcCode}
                                            placeholder="..."
                                            onChange={this.handleDownloadFilterChange}
                                        />
                                    </Col>
                                </FormGroup>
                            </Panel>
                        </Col>
                        <Col sm={12}>
                            {canViewIlocsDownload() ? <FormGroup controlId="submit">
                                <Button
                                    bsStyle={'success'}
                                    onClick={this.validateDownloadDataForm}
                                    href={`${API_BASE_URL}/download-ilocs-report/ILOCS_REPORT_${moment().format(
                                         'DD_MM_YYYY-H_mm'
                                     )}?${this.prepareFormDataForPost(this.state.downloadFilter)}`}
                                >
                                    Download Ilocs Data
                                </Button>
                            </FormGroup> : showAccessDeniedToast()}
                        </Col>
                    </Row>
                </Form>
            </Col>
        );
    }
}

export default IlocsDataDownload;
